<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="moments">
        <div class="moments-left">
          <div class="moments-left-top">
            <router-link :to="{path:'/mycenter',query:{roleId:userid}}"> <img class="bigpicture" v-if="headicon" :src="imgUrl + headicon" />
              <img class="bigpicture" v-else src="../assets/images/mycenterheadpicture.png" /></router-link>
            <div class="headinformation">
              <span>  <img class="headpicture" src="../assets/images/moments_headpicture.png" />
              <span class="name">昵称：{{mininame}}</span></span>
            
            </div>
          </div>
          <div class="moments-left-middle">

          </div>
        </div>
        <div class="moments-right">
          <div class="moments-right-top">
            <div class="upmoment">发表动态</div>

            <el-input class="textarea_up" type="textarea" :rows="2" placeholder="有什么新鲜事分享给大家？" v-model="textarea_up" @keyup.native="handleKeyCode($event)">
            </el-input>
            <el-button type="primary" class="submit" round @click="submitmoment()">发送</el-button>
            <el-upload list-type="picture-card" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile" multiple :limit="9" :on-success="updatepicture" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :file-list="fileList" :class="{ hide: hideUpload }" :on-change="ChangeImage">

              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">

                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file,fileList)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>

            <!-- <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile" multiple :limit="9"  :on-success="updatepicture" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" list-type="picture-card" :auto-upload="false">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" >
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
                  <div> <img width="100%" :src="dialogImageUrl" alt="" class="imgcontainer"></div>

            </el-dialog> -->

          </div>
          <div class="nomoment_title" v-if="!momentItems.length">暂无动态</div>
          <div class="moments-right-bottom" v-else>

            <div class="moments-right-bottom-content" v-for="(item, i) in momentItems" v-if="item.mininame" :key="i">
              <div class="moments_title">
                <router-link :to="{path:'/mycenter',query:{roleId:item.appuserId}}"><img v-if="item.pic" :src="imgUrl + item.pic" class="img_title" alt="" />
                  <img v-else src="../assets/images/mycenterheadpicture.png" class="img_title" alt="" />{{
                    item.mininame | ellipsis
                  }}</router-link>
              </div>
              <div class="introduction">
                <span class="memo_up">{{ item.memo }}</span>
              </div>

              <div class="time">
                <img class="timeicon" src="../assets/images/timeicon.png" />{{item.createTime.substring(0,10)}}
              </div>
              <viewer>
                <div class="momentpicturetotal"> <img v-if="item.pic1" :src="imgUrl + item.pic1" class="momentpicture" />
                  <img v-if="item.pic2" :src="imgUrl + item.pic2" class="momentpicture" />
                  <img v-if="item.pic3" :src="imgUrl + item.pic3" class="momentpicture" />
                  <img v-if="item.pic4" :src="imgUrl + item.pic4" class="momentpicture" />
                  <img v-if="item.pic5" :src="imgUrl + item.pic5" class="momentpicture" />
                  <img v-if="item.pic6" :src="imgUrl + item.pic6" class="momentpicture" />
                  <img v-if="item.pic7" :src="imgUrl + item.pic7" class="momentpicture" />
                  <img v-if="item.pic8" :src="imgUrl + item.pic8" class="momentpicture" />
                  <img v-if="item.pic9" :src="imgUrl + item.pic9" class="momentpicture" /></div>
              </viewer>

              <!-- <el-image style="width: 125px; height: 126px" :src="item.url" :preview-src-list="srcList">
              </el-image> -->
              <img class="remarkbutton" @click="openremark(item.id);" src="../assets/images/remarkbutton.jpg" />
              <div class="remarkarea" v-if="item.id === showid">
                <el-input class="textarea_modify" type="textarea" placeholder="请输入内容" v-model="textarea_modify" maxlength="200" >
                </el-input>
                <el-button type="primary" class="submit_remark" @click="submitcomment(item.id)">发送</el-button>
              </div>
              <div class="remarksubmited" v-for="item1 in item.commentList" :key="item1.id" v-if="item1.memo">
                <div class="remarkposition">
                  <div><span class="memoimg"><img class="remarkicon" src="../assets/images/remarkicon.png" />{{item1.mininame}}：</span>
                    <span class="memo">{{item1.memo}}</span>
                  </div>
                </div>
              </div>
              <div class="line"></div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
const momentItems = []
const listItems = [
  
];
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
import transparentheaders from "../components/transparentheaders.vue";
import {
  queryById,
  addTrends,
  listTrends,
  comment,
  token
} from "../api/api"
export default {
  data() {
    return {
      listItems,
      textarea_up: "",
      textarea_modify: "",
      momentItems,
      fileList: [],
      userid: "",
      mininame: "", //昵称
      headicon: "", //头像
      srcList: [
        require("../assets/images/moments_image1.png"),
        require("../assets/images/moments_image2.png"),

        require("../assets/images/moments_image2.png"),
        require("../assets/images/moments_image1.png"),
        require("../assets/images/moments_image1.png"),

      ],
      imgUrl,
      multipartFile: {
        biz: "app_personPic"
      },

      remarkVisible: false,
      showid: "",
      msg: "",
      dialogVisible: false,
      disabled: false,
      dialogImageUrl: '',
      imgs: [],
      img: [],
      fileList: [],
      hideUpload: false
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.slice(0, 25) + "...";
      }
      return value;
    }
  },
  components: {
    transparentheaders
  },
  created() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
    token().then(res => {
      if (res.data.code == 200) {

      }
    });
    this.getqueryById();
    this.load();

  },
  mounted() {

    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }

  },
  computed: {

  },
  methods: {
    handleRemove(file, fileList) {

      const index = this.fileList.findIndex((item) => {
        return item.uid === file.uid
      })
      this.fileList.splice(index, 1)
      this.imgs.splice(index, 1)
      this.img.splice(index, 1)
      this.hideUpload = false
    },
    ChangeImage(file, fileList) {
      this.hideUpload = fileList.length > 8;
      console.log(this.hideUpload)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    openremark(e) {
      if (this.showid) {
        if (this.showid !== e) {
          this.showid = e;
        } else {
          this.showid = "";
        }

      } else {
        this.showid = e;
      }

      if (this.remarkVisible) {
        this.remarkVisible = false;
      } else {
        this.remarkVisible = true;
      }
    },
    submitcomment(id) {
      const textElement = document.querySelectorAll('.memoimg'); 
      console.log(this.textElement)
      for (let i = 0; i < textElement.length; i++) {
        if (this.textarea_modify.length < 100) {
        textElement[i].style.marginBottom = '10px'
      }
      else {
          textElement[i].style.marginBottom = '70px'
        }
      }
      
      if (this.textarea_modify && !(this.textarea_modify.trim() === "")) {
        let data = {
          appuserId: this.userid,
          memo: this.textarea_modify,
          trendsId: id
        };
        comment(data).then(res => {
          if (res.data.code == 200) {

            this.load();

          }
        });
        this.showid = "";
        this.textarea_modify = "";
      } else {
        this.open();
      }

    },
    submitmoment() {
      if (this.textarea_up && !(this.textarea_up.trim() === "") ||this.imgs.length) {
        let data = {
          appuserId: this.userid,
          memo: this.textarea_up,
          pic1: this.imgs[0] ? this.imgs[0] : '',
          pic2: this.imgs[1] ? this.imgs[1] : '',
          pic3: this.imgs[2] ? this.imgs[2] : '',
          pic4: this.imgs[3] ? this.imgs[3] : '',
          pic5: this.imgs[4] ? this.imgs[4] : '',
          pic6: this.imgs[5] ? this.imgs[5] : '',
          pic7: this.imgs[6] ? this.imgs[6] : '',
          pic8: this.imgs[7] ? this.imgs[7] : '',
          pic9: this.imgs[8] ? this.imgs[8] : '',
        };
        token().then(res => {
          if (res.data.code == 200) {

          }
        });
        addTrends(data).then(res => {
          if (res.data.code == 500) {
            this.load();
            if (res.data.message = "添加成功") {
              res.data.message = "已发表"
            }
            // if (res.data.message = "提交中,请稍后") {
            //   res.data.message = "提交中,请稍后"
            // }
            this.msg = res.data.message;
            console.log(this.msg)
            if (!res.data.message)
              this.msg = "提交失败"

            // this.msg = "已发表" 
            this.opensuccess()
            this.msg = ""
            this.textarea_up = ""
            this.fileList = [];
            this.img = [];
            this.imgs = []
          }
        });

      } else {
        this.open()
      }
    },

    open() {
      this.$alert("内容不能为空", "提示", {
        confirmButtonText: "确定"
        // callback: action => {
        //   this.$message({
        //     // type: 'info',
        //     // message: `action: ${ action }`
        //   });
        // }
      });
    },
    opensuccess() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        center: true,
        confirmButtonText: "确定"
      }).then(() => {

      });
    },
    getqueryById() {
      queryById({
        id: this.userid
      }).then(res => {
        if (res.data.code == 200) {
          this.mininame = res.data.result.mininame;
          this.headicon = res.data.result.personPic
        }
      });
    },
    load() {
      listTrends({
        userId: this.userid,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {

          this.momentItems = res.data.result.records

        }
      });
    },
    updatepicture(res) {
      this.imgs.push(res.message)
      this.img.push(imgUrl + res.message)
      this.fileList = this.img.map(item => {
        return {
          name: item,
          url: item
        }
      });

    },
    handleKeyCode(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation(); //Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.submitmoment();
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.moments {
  margin-top: 70px;
  display: flex;

  height: 90vh;
}

.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  // height: 976px;
  height: 100vh;
  // width: 100%;
}

.white {
  background: white;
}

.moments-left {
  flex-grow: 0.23;
  margin-right: 10px;
  font-size: 26px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  line-height: 4.5;
  flex-wrap: nowrap;

  flex: 0 0 320px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.moments-left-top {
  background: white;
  text-align: center;
  padding: 30px;
  margin-bottom: 10px;
}

.moments-left-middle {
  background: white;
  height: 100%;

  // text-align: left;
}

.name {
  font-size: 16px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  line-height: 4.5;
  text-align: justifyLeft;
}

.moments-right {
  display: flex;
  flex-direction: column;
}

.headinformation {
  margin-top: -28px;
  margin-bottom: -44px;
}

.headpicture {
  margin-top: 3px;
  margin-right: 4px;

}

.bigpicture {
  margin-top: 5px;
  width: 240px;
  height: 240px;
  border-radius: 15px;
  object-fit: cover;
}

.judge {
  margin-top: 20px;
  margin-left: 42px;
  font-size: 16px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  // line-height: 4.5;
  text-align: justifyLeft;
}

.headtext {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(119, 119, 119);
  line-height: 2.571;
  margin-bottom: -3px;
  width: 190px;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  // float: right;
}

.list {
  margin-left: 35px;
}

.listimg {
  margin-bottom: 4px;
}

.moments-right-top {
  background: white;
  // text-align: center;
  margin-bottom: 10px;
  // height: 838px;
  padding: 10px 10px 10px 40px;
}

.moments-right-bottom {
  background: white;
  height: 100%;
  overflow: auto;
  // text-align: left;
  padding: 10px;
}

.moments-right-bottom-content {
  padding: 10px;

}

>>>.el-textarea__inner {
  resize: none;
  background-color: rgb(244, 244, 244);
  height: 100px;
  width: 840px;
  margin-top: 10px;

}

.el-button {
  background-color: rgb(10, 108, 255);
  width: 85px;
  height: 27px;
  margin-left: 744px;
  margin-bottom: 30px;
  margin-top: 43px;
  line-height: 3px;
  letter-spacing: 3px;
  font-size: 14px;
  font-family: "SourceHanSansCN";
  padding: 2px;
  border-radius: 10px;
}

.upmoment {
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  line-height: 2;
  text-align: justifyLeft;

  margin-top: 27px;
}

>>>.upload-demo {
  width: 100px;
}

.moments_title {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  line-height: 1.333;
  text-align: justifyLeft;
  width: 550px;
}

.introduction {
  margin-top: 5px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(152, 152, 152);
  line-height: 1.714;
  text-align: justifyLeft;
  margin-left: 78px;
  word-wrap: break-word;

  width: 700px;
}

.memo_up {
  white-space: pre-wrap;
}

.time {

  display: flex;
  font-size: 14px;
  font-family: "Arial";
  color: rgb(151, 151, 151);
  text-align: justifyLeft;
  line-height: 15px;
}

.timeicon {
  margin-right: 5px;
}

.moments_title {
  margin-top: 15px;
  margin-left: 26px;
}

.momentpicturetotal {
  margin-left: 78px;
  margin-top: 10px;
}

.img_title {
  margin-right: 10px;
  margin-bottom: -20px;
  height: 42px;
  width: 42px;
  border-radius: 10px;
  object-fit: cover;
}

.time {
  margin-left: 78px;
  margin-top: 15px;
}

.remarkbutton {
  margin-left: 800px;
  margin-top: -60px;
  cursor: pointer;
}

.el-image {
  margin-left: 75px;
  margin-top: 20px;
}

.line {
  border: 0.01px solid rgb(218, 236, 253);
  margin-left: 70px;
  width: 775px;
}

.submit_remark {
  margin-top: 30px;
  margin-left: 774px;
  margin-bottom: 10px;
}

>>>.textarea_modify .el-textarea__inner {
  width: 790px;
  margin-left: 70px;
}

// >>> .textarea_remark .el-textarea__inner {
//   width: 790px;
//   height: 50px;
//   margin-left: 70px;
//   background-color: rgb(244, 249, 255);
// }
.remarkarea {}

::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.remarksubmited {
  background: rgb(244, 249, 255);
  margin-left: 70px;
  margin-bottom: 10px;

  width: 780px;
  border-radius: 10px;
  padding: 10px;
  padding-left: 20px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(123, 123, 123);
  line-height: 1.714;

}

.remarkicon {
  margin-right: 10px;
  margin-bottom: 3px;
  
}

.submit {
  margin-bottom: -50px;
  margin-top: 20px;
}

>>>.el-upload-list__item:first-child {
  margin-left: 60px;

  transform: translateY(-65px);
  overflow: hidden;
}

>>>.upload-demo {
  height: 20px;
}

.momentpicture {
  width: 150px;
  height: 150px;
  object-fit: contain;
  margin-right: 50px;
  margin-bottom: 20px;
  border-radius: 15px;
}

.nomoment_title {
  text-align: center;
  padding: 20px;
  height: 100vh;
  background: white;
}

.imgcontainer {
  display: flex;
}

>>>.el-upload-list__item:first-child {
  transform: none !important;
  margin-left: 0px;
}

>>>.el-upload--picture-card {
  margin-top: 20px;

  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  cursor: pointer;
  line-height: 80px;
  vertical-align: top;
}

>>>.el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  margin-top: 20px;
}

>>>.el-upload-list__item.is-uploading {
  display: none;
}

>>>.el-upload-list__item.is-ready {
  display: none;
}

>>>.el-upload-list__item {
  transition: none !important;
}

>>>.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 80px;
  height: 80px;
}

.memo {
  word-wrap: break-word;
  display: block;
  
}
.memoimg {
  float: left;
  
}
</style><style>
.hide .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/moments.vue